module.exports = __webpack_public_path__ + "media/images/version_merge/google_play_btn_gray-275eaff35d04e01ca2bd511e1f62ed3a.svg";